import { act, useEffect, useState } from "react"
import { StandardButton } from "../atoms/buttons"
import { IconAtom } from "../atoms/iconAtom"
import { InputForm, TextAreaForm } from "../atoms/input"
import { Progress } from "../atoms/progress"
import { StandardComp } from "../atoms/standardComp"
import { TextAtom } from "../atoms/TextAtom"
import { TitleAtom } from "../atoms/titleAtom"
import { GridLayout, HorizontalLayout, VerticalLayout } from "../components/layout"
import { getAPI, postAPI } from "../api/api"
import { Spinner } from "../atoms/spinner"
import { borderColor } from "polished"
import { Chip } from "../molecule/Chip"
import logoExpligo from '../assets/expligo_icon.png'
import { Modal, ModalBody, ModalFooter, ModalTitle } from "../components/modal"
export const InitCompany = ({goDashboard}) => {
    const [screen, setScreen] = useState(0)
    const [warning,setWarning] = useState(null)
    const stepInfo = [{ description: "Website analyse en profiel aanmaak" }, { description: "Bedrijfsdoelen en branding" }, { description: "Het profiel van uw bedrijf" }]
    const [loading, setLoading] = useState(false)
    const handleDeepSearch = async (url) => {
        setLoading(true)
        const query = `api/business/info/create`
        const body = {
            url: url
        }
        const search = await postAPI(query, body)
        if (search.status == "ok") {
            setScreen(1)
        }else{
            setWarning()
        }

        setLoading(false)
    }
    const finish = () => {
        goDashboard()
    }
    return (
        <VerticalLayout
            className="body-screen standard-padding"
            style={{ boxSizing: "border-box", alignItems: "center" }}
        >
            <VerticalLayout className={"init-screen"} style={{ gap: "1rem" }}>
                <InitStepNav step={screen + 1} description={stepInfo[screen].description} />
                <InitSetupComp goNext={() => setScreen(screen + 1)} finish={finish} isLoading={loading} search={handleDeepSearch} screen={screen} />
            </VerticalLayout>
        </VerticalLayout>
    )
}


const InitSetupComp = ({ screen, search, isLoading, finish, goNext, warning }) => {
    const [goals, setGoals] = useState([
  {
    "goal": "Snelle groei",
    "icon": "trending-up",
    "id_goal": "",
    "description": "Versnel de groei van je bedrijf door meer kwalitatieve leads te genereren."
  },
  {
    "goal": "Efficiënte onboarding",
    "icon": "user-check",
    "id_goal": "",
    "description": "Zorg voor een soepele en effectieve onboarding van nieuwe klanten."
  },
  {
    "goal": "Merk uitingen",
    "icon": "megaphone",
    "id_goal": "",
    "description": "Vergroot de zichtbaarheid van je merk en blijf positief in de perceptie van klanten."
  },
  {
    "goal": "Hoge retentie",
    "icon": "users",
    "id_goal": "",
    "description": "Verhoog klantloyaliteit door uitstekende ondersteuning en service te bieden."
  }
])
    const [brandingGoals, setBrandingGoals] =  useState([
  {
    goal: "Merkbekendheid vergroten",
    icon: "megaphone",
    id_goal: "",
    description: "Maak je merk zichtbaar en herkenbaar bij een breed publiek."
  },
  {
    goal: "Consistente merkidentiteit",
    icon: "palette",
    id_goal: "",
    description: "Zorg voor een consistente uitstraling in al je communicatie en visuals."
  },
  {
    goal: "Positieve merkperceptie",
    icon: "smile",
    id_goal: "",
    description: "Bouw vertrouwen en een positieve indruk bij klanten en prospects."
  },
  {
    goal: "Sterke online aanwezigheid",
    icon: "globe",
    id_goal: "",
    description: "Vergroot je digitale zichtbaarheid via sociale media en contentmarketing."
  }
]);
    const selectBrandingGoal = (index) => {
        const copyBranding = [...brandingGoals]
        copyBranding[index].active = !copyBranding[index].active
        setBrandingGoals(copyBranding)
    }
    const selectGoal = (index) => {
        const copyGoals = [...goals]
        copyGoals[index].active = !copyGoals[index].active
        setGoals(copyGoals)
    }

    const insertItems = async () => {
        const query = `api/business/detailed-info/create`
        const body = {"goals":[], "branding":[]}
        body.goals = goals.filter((goal) => goal.active)
        body.branding = brandingGoals.filter((branding) => branding.active)
        console.log(body)
        const insert = await postAPI(query, body)
        if(insert.status == "ok"){
            goNext()
        }
    }
    switch (screen) {
        case 0: return <WebsiteSearchComp warning={warning} search={search} isLoading={isLoading} />
        case 1:
            return (
                <VerticalLayout style={{ gap: "1rem", width: "unset" }}>
                    <BusinessGoals selectGoal={(index) => selectGoal(index)} goals={goals} />
                    <BrandGoals brandingGoals={brandingGoals} selectBrandingGoal={(index) => selectBrandingGoal(index)} />
                    <StandardButton
                        onClick={insertItems}
                        style={{ width: "100%", margin: 0, textAlign: "center", justifyContent: "center", alignItems: "center", fontWeight: "bold", fontSize: "1.2rem" }}
                        title={"Afronden"}
                    />
                </VerticalLayout>
            )

        case 2: return (
            <>
                <SummaryComp />
                <StandardButton
                    onClick={finish}
                    className={"heavy-shadow"}
                    style={{ width: "100%", margin: 0, textAlign: "center", justifyContent: "center", alignItems: "center", fontWeight: "bold", fontSize: "1.2rem" }}
                    title={"Klaar om te starten"}
                />
            </>
        )
    }
}

const BusinessGoals = ({ selectGoal, goals }) => {

    return (
        <StandardComp editClass={"heavy-shadow"} style={{ marginRight: "0" }}>
            <VerticalLayout style={{ width: "unset", gap: "1rem" }}>
                <TitleSub
                    title={"Wat is je belangrijkste bedrijfsdoelstelling?"}
                    sub={"Kies een van de onderstaande doelstellingen om zo direct gericht aan de slag te kunnen in de software"}
                />
                <GridLayout
                    gap={"1rem"}
                    className="grid-2-4"
                >
                    {goals.map((goal, index) => {
                        return (
                            <GoalModule
                                selectGoal={() => selectGoal(index)}
                                key={goal.id_goal}
                                title={goal.goal}
                                description={goal.description}
                                icon={goal.icon}
                                selected={goal.active}
                            />
                        )
                    })}
                </GridLayout>
            </VerticalLayout>
        </StandardComp>
    )
}

const BrandGoals = ({ selected, selectBrandingGoal, brandingGoals }) => {

    return (
        <StandardComp editClass={"heavy-shadow"} style={{ marginRight: "0", borderColor: selected && "var(--primary-500)" }}>
            <VerticalLayout style={{ width: "unset", gap: "1rem" }}>
                <TitleSub
                    title={"Wat wil je uitstralen met je merk?"}
                    sub={"Kies een van de onderstaande uitingskenmerken."}
                />
                <GridLayout
                    gap={"1rem"}
                    className="grid-4-2"
                >
                    {brandingGoals.map((goal, index) => {
                        return (
                            <BrandingModule
                                selectBrand={() => selectBrandingGoal(index)}
                                key={goal.id_goal}
                                title={goal.goal}
                                description={goal.description}
                                icon={goal.icon}
                                selected={goal.active}
                            />
                        )
                    })}
                </GridLayout>
            </VerticalLayout>
        </StandardComp>
    )
}

const GoalModule = ({ title, description, icon, selected, selectGoal }) => {
    return (
        <StandardComp onClick={selectGoal} style={{ marginRight: "0", borderColor: selected && "var(--primary-500)" }}>
            <HorizontalLayout style={{ width: "unset", gap: "1rem" }}>
                <IconAtom
                    iconSize={50}
                    color={"var(--primary-600)"}
                    icon2={icon}
                />
                <VerticalLayout>
                    <TextAtom
                        style={{ fontWeight: "bold" }}
                        title={title}
                    />
                    <TextAtom
                        title={description}
                        style={{ color: "var(--grey-600)", fontSize: "0.8rem" }}
                    />
                </VerticalLayout>
            </HorizontalLayout>
        </StandardComp>
    )
}

const BrandingModule = ({ title, description, icon, selected, selectBrand }) => {
    return (
        <StandardComp onClick={selectBrand} style={{ marginRight: "0", borderColor: selected && "var(--primary-500)" }}>
            <VerticalLayout style={{ width: "unset", gap: "1rem" }}>
                <IconAtom
                    iconSize={50}
                    color={"var(--primary-600)"}
                    icon2={icon}
                />
                <VerticalLayout>
                    <TextAtom
                        style={{ fontWeight: "bold" }}
                        title={title}
                    />
                    <TextAtom
                        title={description}
                        style={{ color: "var(--grey-600)", fontSize: "0.8rem" }}
                    />
                </VerticalLayout>
            </VerticalLayout>
        </StandardComp>
    )
}
const InitStepNav = ({ description, step }) => {
    return (
        <StandardComp editClass={"heavy-shadow"} style={{ marginRight: 0, display: 'flex', gap: "0.5rem", flexDirection: "column", shadowBox: "rgba(0, 0, 0, 0.05) 0px 8px 12px 0px" }}>
            <HorizontalLayout style={{ justifyContent: "space-between" }}>
                <TextAtom
                    style={{ fontWeight: "bold" }}
                    title={`stap ${step} van 3`}
                />
                <TextAtom
                    style={{ color: "var(--primary-600)", fontWeight: "bold" }}
                    title={` ${Math.round(step / 3 * 100)}% van 100%`}
                />
            </HorizontalLayout>
            <Progress round={true} height="0.5rem" percentage={Math.round(step / 3 * 100)} />
            <TextAtom
                style={{ color: "var(--grey-600)", fontSize: "0.8rem" }}
                title={description}
            />
        </StandardComp>

    )
}
const WebsiteSearchComp = ({ search, isLoading }) => {
    const [url, setUrl] = useState("")
    const handleSearchNow = () => {
        search(url)
    }
    return (
        !isLoading ?
            <StandardComp editClass={"heavy-shadow"} style={{ marginRight: "0", padding: "5rem" }}>
                <VerticalLayout style={{ alignItems: "center", gap: "1rem" }}>
                    <IconAtom iconSize={50} icon2={"globe"} color={"var(--primary-600)"} />
                    <TitleSub
                        title={"Laten we wat meer te weten komen over je bedrijf"}
                        sub={"Doormiddel van je website krijgen we snel een beter inzicht in je bedrijfsdoelen, producten en branding."}
                    />

                    <InputForm
                        typeInput={(text) => setUrl(text)}
                        value={url}
                        placeholder={"https://www.voorbeeld.nl/"}
                        title={"Website url"}
                    />

                    {isLoading ? <TextAtom title={"Website bezoeken en bewonderen!"}></TextAtom> : <StandardButton
                        style={{ width: "100%", justifyContent: "center", alignItems: "center", fontWeight: "bold", marginLeft: "0" }}
                        onClick={handleSearchNow}
                        title={"Doorzoek website"}
                    />}
                    <HorizontalLayout style={{ alignItems: "center", width: "unset", gap: "1rem" }} >
                        <Secure icon={"shield"} title={"Privacy"} />
                        <Secure icon={"clock"} title={"Duurt minder dan 30 sec.."} />
                    </HorizontalLayout>

                </VerticalLayout>


            </StandardComp>
            :


            <StandardComp editClass={"heavy-shadow"} style={{ marginRight: "0", padding: "5rem" }}>
                <VerticalLayout style={{ alignItems: "center", gap: "1rem" }}>
                    <IconAtom iconSize={50} icon2={"globe"} color={"var(--primary-600)"} />
                    <TitleAtom style={{ textAlign: "center" }} title={"Laten we wat meer te weten komen over je bedrijf"} />
                    <TextAtom style={{ textAlign: "center", color: "var(--grey-600)", fontSize: "0.8rem" }} title={"Doormiddel van je website krijgen we snel een beter inzicht in je bedrijfsdoelen, producten en branding."} />
                    <Spinner size={50} />

                    <HorizontalLayout style={{ alignItems: "center", width: "unset", gap: "1rem" }} >
                        <Secure icon={"shield"} title={"Privacy"} />
                        <Secure icon={"clock"} title={"Duurt minder dan 30 sec.."} />
                    </HorizontalLayout>

                </VerticalLayout>


            </StandardComp>
    )
}

export const SummaryComp = () => {
    return (
        <VerticalLayout>
            <IconAtom />
            <TitleSub />
            <SummaryModule />
        </VerticalLayout>
    )
}

const SummaryModule = () => {
    const [profile, setProfile] = useState({goals:[], branding:[], summary:"", opportunities:""})
    const [activeModal, setActiveModal] = useState(false)
    const close = () => {
            setActiveModal(false)
    }
    useEffect(() => {
        loadProfile() 
    },[])
    const loadProfile = async () => {
        const query = `api/business/detailed-info`
        const loadedProfile = await getAPI(query)
        setProfile(loadedProfile.data)
    }
    return (
        <StandardComp editClass={"heavy-shadow"} style={{ margin: 0, height:"20rem" }}>
            <HorizontalLayout style={{ width: "unset", alignItems: "flex-start", gap: "3rem", height:'100%' }}>
                {/* <div style={{ width: "12rem", margin: "-1.5rem", display:"flex", backgroundColor: "var(--primary-100)", justifyContent: "center", overflow: "hidden", borderTopLeftRadius: "1rem", borderBottomLeftRadius: "1rem", height:'calc(100% + 3rem)' }}>
                <img style={{ height: "calc(100% + 3rem)"}} src={logoExpligo} />
                </div> */}
                <VerticalLayout style={{ gap: "1rem", height:"unset" }}>
                    <HorizontalLayout>
                        <TitleAtom
                            title={"Bedrijfsoverzicht"}
                        />
                        <EditComp editNow={() => setActiveModal(true)} />

                    </HorizontalLayout>

                    <HorizontalLayout>
                        <ProfileModule
                            chips={profile?.goals}
                            title={"DOELEN"}
                        />
                        <ProfileModule

                            chips={profile?.branding}
                            title={"BRANDING"}
                        />
                    </HorizontalLayout>

                    <ExtraInfoModule
                        title={"Samenvatting"}
                        text={profile.summary}
                    />
                    <ExtraInfoModule
                        title={"Kansen"}
                        text={profile.opportunities}
                    />

                </VerticalLayout>
            </HorizontalLayout>
            <EditModal data={profile} close={close} active={activeModal} />
        </StandardComp>
    )
}

const EditModal = ({ active, data, close }) => {
    const [textValue, setTextValue] = useState({ summary: data?.summary, opportunities: data?.opportunities })
    const save = () => {
        close()
    }
    return (
        <Modal visible={active} >
            <ModalTitle title={"Pas aan"}></ModalTitle>
            <ModalBody>
                <TextAreaForm
                    title={"Samenvatting"}
                    value={(textValue?.summary) ? textValue?.summary: data.summary}
                    typeInput={(text) => setTextValue({ ...textValue, summary: text })}
                >

                </TextAreaForm>
                <TextAreaForm
                    title={"Kansen"}
                    value={(textValue?.opportunities) ? textValue?.opportunities: data.opportunities}
                    typeInput={(text) => setTextValue({ ...textValue, opportunities: text })}
                />

            </ModalBody>
            <ModalFooter>
                <StandardButton title={"Opslaan"} onClick={save}>

                </StandardButton>
            </ModalFooter>
        </Modal>
    )
}

const EditComp = ({ editNow}) => {
    return (
        <HorizontalLayout style={{ width: "unset", gap:"0.3rem" }} onClick={editNow}>
            <IconAtom
                color={"var(--primary-600)"}
                size={12}
                icon2={"edit"}
            />
            <TextAtom
                style={{ fontSize: "0.7rem", color: "var(--primary-600)", width:"3rem", fontWeight:"bold" }}
                title={"Pas aan"}
            />
        </HorizontalLayout>
    )
}

const ProfileModule = ({ title, chips }) => {
    return (
        <VerticalLayout>
            <TextAtom
                style={{fontWeight:"", color:"grey", fontSize:"0.8rem"}}
                title={title}
            />
            {chips.map((chip) => {
                return (
                    <Chip
                        style={{ backgroundColor: "var(--primary-100)", width: "max-content" }}
                        disabled={false}
                        label={chip.title}
                    />
                )
            })}

        </VerticalLayout>)
}
const ExtraInfoModule = ({ title, text }) => {
    return (


        <VerticalLayout>
            <TextAtom
                style={{ fontWeight: "bold" }}
                title={title}
            />
            <TextAtom
                style={{color:"grey"}}
                title={text}
            />

        </VerticalLayout>
    )

}

const Secure = ({ icon, title }) => {
    return (
        <HorizontalLayout style={{ alignItems: "center", width: "unset", gap: "0.2rem", justifyContent: "center" }}>
            <IconAtom color={"var(--grey-600)"} iconSize={13} icon2={icon} />
            <TextAtom style={{ textAlign: "center", color: "var(--grey-600)", fontSize: "0.8rem" }} title={title} />
        </HorizontalLayout>
    )
}


const TitleSub = ({ title, sub }) => {
    return (
        <>
            <TitleAtom style={{ textAlign: "center" }} title={title} />
            <TextAtom style={{ textAlign: "center", color: "var(--grey-600)", fontSize: "0.8rem" }} title={sub} />
        </>
    )
}